import * as Yup from 'yup';

export const CreateAreaSchema = Yup.object().shape({
  areaId: Yup.string().min(1).required('Area name is required'),
  price: Yup.string().min(1).required('Price is required'),
});

export type CreateAreaDataType = Yup.InferType<typeof CreateAreaSchema>;

type InitialValues = {
  areaId: string;
  price: string;
};

export const CreateAreaInitialValues: InitialValues = {
  areaId: '',
  price: '',
};

export interface ICreateAreaResponse {
  id: string;
  warehouseId: string;
  amount: number;
  areaId: number;
  areaName: string;
  createdBy: string;
  createdDate: string;
}

export interface ICreateAreaRequest {
  areaId: number;
  price: number;
}
